import React from "react"
import { useTranslation } from "react-i18next"
import { Button, Dialog, DialogBody, DialogFooter, Flex, Typography } from "@strapi/design-system"
import { ExclamationMarkCircle, Trash } from "@strapi/icons"

interface ConfirmDialogProps {
  isOpen: boolean
  text: string
  onClose: () => void
  onConfirm: () => void
}

const ConfirmDialog = ({ isOpen, onClose, onConfirm, text }: ConfirmDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog onClose={onClose} title="Confirmation" isOpen={isOpen}>
      <DialogBody icon={<ExclamationMarkCircle />}>
        <Flex direction="column" alignItems="center" gap={2}>
          <Flex justifyContent="center">
            <Typography id="confirm-description">{text}</Typography>
          </Flex>
        </Flex>
      </DialogBody>
      <DialogFooter
        startAction={
          <Button onClick={onClose} variant="tertiary">
            {t("cancel")}
          </Button>
        }
        endAction={
          <Button variant="danger-light" startIcon={<Trash />} onClick={onConfirm}>
            {t("confirm")}
          </Button>
        }
      />
    </Dialog>
  )
}

export default ConfirmDialog
